// External Dependencies
import React, { Component } from 'react';
import PropTypes from 'prop-types';
import Divider from 'material-ui/Divider';
import FlatButton from 'material-ui/FlatButton';
import Paper from 'material-ui/Paper';
import { Link } from 'react-router';
import { List, ListItem } from 'material-ui/List';
import {
  grey600,
  teal500,
} from 'material-ui/styles/colors';

// Internal Dependencies
import AddToCalendar from './AddToCalendar';
import ClockIcon from '../shared/icons/clock';
import connectComponent from '../connect-component';
import LocationIcon from '../shared/icons/location';
import MailIcon from '../shared/icons/mail';
import styles from '../styles/Styles';
import { getNextEvent } from '../state/actions/event-actions';
import { HomePageStrings } from '../common/strings';

// Local variables
const propTypes = {
  eventData: PropTypes.object,
  getNextEvent: PropTypes.func,
};

const dateStyles = {
  alignItems: 'center',
  display: 'flex',
  flexDirection: 'column',
  justifyContent: 'space-around',
  padding: 32,
  textAlign: 'center',
};

const dateNumberStyles = {
  fontSize: 90,
  fontWeight: '100',
};

const heroSubtitleStyles = {
  fontSize: 18,
  width: '100%',
  fontWeight: '300',
  lineHeight: 1.6,
  textAlign: 'center',
  color: grey600,
};

const helloWorldTextStyles = {
  color: teal500,
  fontSize: 40,
  fontWeight: 300,
  lineHeight: 1.6,
  textAlign: 'center',
  marginTop: 0,
};

const ninjaIconStyles = {
  marginBottom: 16,
  marginTop: 16,
};

const viewNinjasButtonStyles = {
  marginTop: 32,
};

const nextEventLeftContainerStyles = {
  lineHeight: 1.6,
  marginLeft: '15%',
  padding: '1%',
  textAlign: 'center',
};

const nextEventLeftImageStyles = {
  position: 'relative',
  top: 16,
};

const nextEventTextStyles = {
  ...helloWorldTextStyles,
  color: 'black',
};

const viewBadgesButtonStyles = { marginTop: '32px' };

const picDivTextStyles = {
  color: 'white',
  fontWeight: '300',
  height: '100%',
  lineHeight: 1.6,
  marginLeft: '20%',
  marginTop: 32,
  textAlign: 'center',
  width: '40%',
};

const textStyles = {
  ...helloWorldTextStyles,
  color: 'white',
};

const eventContainerStyles = {
  ...styles.pictureContainer,
  background: '#263238',
  color: 'white',
  display: 'flex',
  fontFamily: 'Work Sans,san serif',
  fontSize: '20pt',
  fontWeight: '300',
  marginLeft: 10,
  padding: 0,
};

const infoListStyles = {
  ...styles.homePageHelloDiv,
  textAlign: 'left',
  width: 300,
};

const locationIconStyles = {
  ...styles.iconStyle,
  top: 10,
};

const badgeIconImage = `${window.location.pathname}images/quality.svg`;
const heartImage = `${window.location.pathname}images/heart.png`;
const image = `${window.location.pathname}images/people.jpg`;
const ninjaIconImage = `${window.location.pathname}images/ninja-face.svg`;

// Component definition
class HomePageContent extends Component {
  componentDidMount() {
    this.props.getNextEvent();
  }

  render() {
    const { eventData } = this.props;
    const fallbackAddress = "3803 Parkwood Blvd, Suite 900, Frisco, TX 75034";

    return (
      <div>
        <div style={styles.homePageHelloDiv}>
          <h1 style={helloWorldTextStyles}>{HomePageStrings.WELCOME_TXT}</h1>
          <div style={heroSubtitleStyles}>
            {HomePageStrings.HOME_INTRO_1}
            <br /> {HomePageStrings.HOME_INTRO_2}
            <br /> {HomePageStrings.HOME_INTRO_3}
          </div>
        </div>

        <div style={styles.homePagePicDiv}>
          <Paper rounded={false} style={styles.pictureContainer} zDepth={3}>
            <img alt={image} src={image} style={styles.homePagePicture} />
          </Paper>
          <div style={picDivTextStyles}>
            <div style={textStyles}>
              {HomePageStrings.ITS_FREE}
            </div>
            {HomePageStrings.ITS_FREE_1}
            <br />
            They will
            <img alt={heartImage} src={heartImage} style={styles.heartPicture} />
            it.
            <br />
            <img
              alt={ninjaIconImage}
              height="40px"
              src={ninjaIconImage}
              style={ninjaIconStyles}
            />
            <br />
            {HomePageStrings.FIND_NINJAS}
            <br />
            <Link to="/CodersPage">
              <FlatButton
                backgroundColor="#fff"
                hoverColor="#ebebeb"
                label={HomePageStrings.VIEW_NINJAS}
                style={viewNinjasButtonStyles}
              />
            </Link>
          </div>
        </div>

        <div style={styles.homePageEventDiv}>

          <div style={nextEventLeftContainerStyles}>
            <div style={nextEventTextStyles}>NEXT EVENT</div>
            <br /> {HomePageStrings.WIN_BADGES}
            <br />
            <img
              alt={badgeIconImage}
              height="50px"
              src={badgeIconImage}
              style={nextEventLeftImageStyles}
            />
            <br />
            <Link to="/BadgeList">
              <FlatButton
                backgroundColor="#fff"
                hoverColor="#ebebeb"
                label={HomePageStrings.VIEW_BADGES}
                style={viewBadgesButtonStyles}
              />
            </Link>
          </div>

          <Paper
            rounded={false}
            style={eventContainerStyles}
            zDepth={3}
          >
            <div style={dateStyles}>
              {eventData.day}<br /><br />
              {eventData.month}
              <div style={dateNumberStyles}>
                {eventData.date}
              </div>
            </div>
            <div style={infoListStyles}>
              <List>
                <ListItem
                  disabled
                  leftIcon={<LocationIcon style={locationIconStyles} />}
                  primaryText={eventData.address || fallbackAddress}
                />
                <Divider inset />
                <ListItem
                  disabled
                  leftIcon={<ClockIcon style={styles.iconStyle} />}
                  primaryText="9:30am - 11:30am"
                />
                <Divider inset />
                <ListItem
                  disabled
                  leftIcon={<MailIcon style={styles.iconStyle} />}
                  primaryText="dojo@call-em-all.com"
                />
                <ListItem insetChildren disabled>
                  <AddToCalendar eventData={eventData} />
                </ListItem>
              </List>
            </div>
          </Paper>
        </div>
      </div>
    );
  }
}
HomePageContent.propTypes = propTypes;
export default connectComponent(state => ({
  eventData: state.eventData,
}), {
  getNextEvent,
}, HomePageContent);



/** WEBPACK FOOTER **
 ** ./src/home/HomePageContent.js
 **/